<template>
  <div class="common-documents">
      <div class="card-subtitle mb-3">Общие</div>
      <div class="my-1">
        <public-link to="/page/using-rules"
                     target="_blank"
        >Правила пользования</public-link>
      </div>
      <div class="my-1">
        <public-link to="/page/dogovor-po-sodeistviiu-v-investirovanii"
                     target="_blank"
        >Условия договора по содействию в инвестирование</public-link>
      </div>
    </div>
</template>

<script>
import { PublicLink } from "@/components/common";

export default {
  name: "CommonDocuments",
  components: {
    PublicLink
  }
}
</script>
